import {
  RequestWrapper,
  extGet,
} from './requests';

const baseURL = 'https://viacep.com.br/ws';

const availableReturnTypes: Array<string> = [
  'json', 'xml', 'piped', 'querty',
];

const fetchCepDetails = (params: {
  cep: string | number | undefined,
  returnType: string | undefined,
  unicode?: boolean,
} = {
  cep: undefined,
  returnType: 'json',
  unicode: true,
}): RequestWrapper => {
  if (!params.cep) {
    throw new Error('Cep não informado');
  }

  if (!params?.returnType || !availableReturnTypes.includes(params.returnType)) {
    throw new Error('O tipo de retorno informado é inválido');
  }

  let url = `${baseURL}/${params.cep}/${params.returnType}`;

  if (params.unicode) {
    url += '/unicode';
  }

  return extGet({
    url,
  });
};

export {
  fetchCepDetails,
};
